import { RouterInputs, ReactQueryOptions, api, RouterOutputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { TRPCClientErrorLike } from '@trpc/client'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'

type inputType = RouterInputs['CollectionManager']['getList']
type queryOptionsType = ReactQueryOptions['CollectionManager']['getList']

export const useGetCollections = (input: inputType, options?: queryOptionsType) => {
    return api.CollectionManager.getList.useQuery(input, {
        ...options,
        queryKey: ['CollectionManager.getList', input],
        staleTime: 1000 * staleTimeIndex * 60 * 60, // 1 hour
    })
}

type outputType = RouterOutputs['CollectionManager']['getList']
type optionsType = UseTRPCInfiniteQueryOptions<'CollectionManager.getList', inputType, outputType, TRPCClientErrorLike<any>>

export const useGetCollectionsInfinityList = (input: inputType, options?: optionsType) => {
    return api.CollectionManager.getList.useInfiniteQuery(input, {
        ...options,
        queryKey: ['CollectionManager.getList', input],
        staleTime: 1 * 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        initialCursor: undefined,
    })
}
